import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { deleteDriverTran } from 'redux/booking/car/carBookingSlice';
import { Confirmation } from 'components/common';

const DriverTranDeleteConfirm = ({ showModal, setshowModal, transaction, driverTran }) => {
  const dispatch = useDispatch();

  const closeModal = () => setshowModal(false);

  const handleConfirm = () => {
    try {
      dispatch(deleteDriverTran({ transactionId: transaction.id, driverTranId: driverTran?.id }));
      closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Confirmation
      show={showModal}
      type="warning"
      title="Cancel driver for car booking!"
      message={`Booking ${transaction.booking_number} was approved. Are you sure to cancel driver ${driverTran?.driver?.name}?`}
      confirmText="Yes"
      cancelText="No"
      onConfirm={handleConfirm}
      onCancel={closeModal}
    />
  );
};

DriverTranDeleteConfirm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  transaction: PropTypes.object.isRequired,
  driverTran: PropTypes.object,
};

export default DriverTranDeleteConfirm;
